/**
 * Guestbook entry point. The page is complete without this file: signing is a plain
 * form post, replying is a query parameter, and the reply threads are <details>. What
 * loads here is the unfolding of a linked-to reply, and the admin review buttons -- the
 * latter only when the server rendered the page for an admin session. /api/admin/*
 * re-checks the session on every request; this file is convenience, not the security
 * boundary.
 */

// A link straight to a reply (#e-12) has to open the thread it's folded into first; not
// every browser unfolds a closed <details> for a fragment on its own.
const unfoldTarget = () => {
  const target = location.hash && document.getElementById(location.hash.slice(1));
  const thread = target?.closest('details.thread');
  if (!thread || thread.open) return;
  thread.open = true;
  target.scrollIntoView();
};
unfoldTarget();
window.addEventListener('hashchange', unfoldTarget);

if (document.body.hasAttribute('data-admin')) {
  const call = async (path, method) => {
    const res = await fetch(path, { method });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    location.reload();
  };
  const idOf = (btn) => btn.closest('.entry').dataset.id;

  document.querySelectorAll('.entry__approve').forEach((btn) =>
    btn.addEventListener('click', () =>
      call(`/api/admin/guestbook/${idOf(btn)}/approve`, 'POST'),
    ),
  );

  // Two-beat delete instead of a confirm() -- same effect, no browser modal.
  document.querySelectorAll('.entry__delete').forEach((btn) =>
    btn.addEventListener('click', () => {
      if (btn.textContent !== 'sure?') {
        btn.textContent = 'sure?';
        return;
      }
      call(`/api/admin/guestbook/${idOf(btn)}`, 'DELETE');
    }),
  );
}
